import React from 'react'

import Immutable from 'immutable'
import { useSelector } from 'react-redux'

import { getNumPortions } from 'selectors/basket'

import { IngredientImage } from './IngredientImage'

import css from './Ingredient.css'

type IngredientProps = {
  ingredient: Immutable.Map<string, any>
  loading: boolean
}

const LoadingSkeleton = ({ style }: { style?: React.CSSProperties }) => (
  <span className={css.loadingSkeleton} style={style} data-testid="LoadingSkeleton" />
)

const Ingredient = ({ ingredient, loading }: IngredientProps) => {
  const numPortion = useSelector(getNumPortions)
  const quantity = ingredient.getIn(['quantities', `for${numPortion}`, 'in_meal'])
  const label = `${ingredient.get('name')}${quantity !== 1 ? ` x ${quantity}` : ''}`

  return (
    <div className={css.ingredient}>
      <div className={css.imageContainer}>
        {loading ? (
          <LoadingSkeleton style={{ height: '125px', borderRadius: '50%' }} />
        ) : (
          <IngredientImage ingredient={ingredient} />
        )}
      </div>
      <div className={css.label}>{loading ? <LoadingSkeleton /> : <span>{label}</span>}</div>
    </div>
  )
}

export { Ingredient }
